import { navigateTo } from "#imports";
import { useAuthBootstrap } from "~/composables/useAuthBootstrap";
import { useLoginResponse } from "~/composables/useLoginResponse";

const PUBLIC_PATHS = new Set(["/login", "/register", "/info"]);
const normalizePath = (path: string) => {
  if (path === "/") return "/";
  return path.replace(/\/+$/, "") || "/";
};

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return;

  if (PUBLIC_PATHS.has(normalizePath(to.path))) return;

  const { isAuthorized, ensureBootstrap, rememberReturnTo } = useAuthBootstrap();
  const { hydrateLoginResponse, isRouteAllowed } = useLoginResponse();
  await ensureBootstrap(to.fullPath);

  if (!isAuthorized.value) {
    rememberReturnTo(to.fullPath);
    return navigateTo({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  }

  hydrateLoginResponse();

  if (!isRouteAllowed(to.path)) {
    return navigateTo("/");
  }
});
